<ng-container *transloco="let t">
  <div class="position-relative" #inputGroup>
    <input
      vinnova-text-input
      type="text"
      class="form-control"
      [placeholder]="t('datepicker_placeholder')"
      (change)="inputChange()"
      [attr.type]="isMobile ? 'date' : undefined"
      [disabled]="isDisabled"
      [(ngModel)]="value"
      [error]="isInvalid"
      [attr.id]="id"
      #datepickerInput
      autocomplete="off"
      [inputType]="isMobile ? undefined : InputType.Date"
      (focus)="datepickerFocus.emit()"
      (blur)="datepickerBlur.emit()"
    />
    <button
      class="icon-btn open-calendar-btn"
      type="button"
      (click)="toggleDatepicker()"
      [attr.aria-label]="t('datepicker_aria_open_calendar', { date: value })"
    >
      <lib-icon name="calendar" size="small"></lib-icon>
    </button>
  </div>
</ng-container>
